import React from 'react';
const linkClass = 'transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-brand';
export function Footer() {
  return <footer className="bg-stone-50" data-id="element-78" data-mp="3ggtxgg3gzf46">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 py-12 text-center" data-id="element-79" data-mp="32nummremu92y">
        <p className="font-serif text-lg font-bold text-stone-900" data-id="element-80" data-mp="36pfutzg81z6t">MegaPack Contabilidad Lista</p>
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-stone-600" data-id="element-81" data-mp="3uf0nxb63actt">
          Pago único · Descarga digital
        </p>
        <nav aria-label="Enlaces legales" data-id="element-82" data-mp="37o6qw57hzdw">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-stone-600" data-id="element-83" data-mp="36d3qyjl4vnu">
            <li data-id="element-84" data-mp="3qdf4t82yp2b6">
              <a href="#politica-reembolso" id="politica-reembolso" className={linkClass} data-id="element-85" data-mp="3qcxawi3rv06f">
                Política de reembolso
              </a>
            </li>
            <li data-id="element-86" data-mp="2a19uhoqc1syc">
              <a href="#terminos" className={linkClass} data-id="element-87" data-mp="2eya1c1v0azqi">
                Términos y condiciones
              </a>
            </li>
            <li data-id="element-88" data-mp="3l8qx26bccnsi">
              <a href="#privacidad" className={linkClass} data-id="element-89" data-mp="3labrlvxno6qd">
                Privacidad
              </a>
            </li>
            <li data-id="element-90" data-mp="3gca6l5go5xc9">
              <a href="#contacto" className={linkClass} data-id="element-91" data-mp="3gctrmv1m91ui">
                Contacto
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>;
}